import { useTranslation } from '../i18n'
import LinkButton from './LinkButton'

export default function Footer() {
  const { t } = useTranslation()
  const currentYear = new Date().getFullYear()
  const footerData = [
    { title: t('footer.contactUs'), to: '/help' },
    { title: t('footer.features'), to: '/features' },
    { title: t('footer.advertise'), to: '/ads' },
    { title: t('footer.company'), to: 'https://www.odkmedia.net', newTab: true },
    { title: t('footer.privacyPolicy'), to: 'https://www.odkmedia.net/privacy-policy', newTab: true },
    { title: t('footer.termsOfUse'), to: '/terms-of-use' },
    {
      title: t('footer.doNotSellMyPersonalInformation'),
      to:
        'https://privacyportal.onetrust.com/webform/5ace1796-24fd-4b65-9564-9e8e8df7ec5d/6adc38fb-7317-430f-aecb-7382f7162dd3',
      newTab: true,
    },
  ]
  return (
    <footer className="Footer">
      <div className="Footer__inner">
        <ul className="Footer__links">
          {footerData.map(data => (
            <li key={data.to}>
              <LinkButton className="Footer__link" theme="text" size="small" color="black" {...data} external />
            </li>
          ))}
        </ul>
        <p className="Footer__copyright">
          &copy; 2012-{currentYear} ODK Media, Inc.
          <br />
          OnDemandKorea &amp; Design Reg. U.S. Pat. &amp; Tm. Off.
        </p>
      </div>
    </footer>
  )
}
